import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { IncentiveStep } from 'interfaces';
import { Ref } from 'vue';

export default class DirectSigninButton {
	constructor(private readonly store: IIncentiveV2Store, private readonly isRegister: Ref<boolean>) {}

	public goToDirectRegistation(): void {
		this.isRegister.value = true;
		this.store.mutations.setStep(IncentiveStep.LOGIN);
	}
}
